/*
    Create by fanglijuan 2017-05-26
*/
'use strict';
angular.module("createAccountSynchroToPersonalModule", [])
    .controller("createAccountSynchroToPersonalCtrl", ["$scope", "$location", "$stateParams", "$q", "$filter", "$timeout", "$modalInstance", "trsHttpService", 'treeService', "$state", "$validation", "item", "whichTabShow", "trsspliceString", "globleParamsSet", "modalDialog", "accountSynchroToPersonalService",'nameChange',
        function($scope, $location, $stateParams, $q, $filter, $timeout, $modalInstance, trsHttpService, treeService, $state, $validation, item, whichTabShow, trsspliceString, globleParamsSet, modalDialog, accountSynchroToPersonalService,nameChange) {
            initStatus();
            initData();

            function initStatus() {
                $scope.status = {
                    SynUserId: item.SYNUSERID, //用户id
                    whichTabShow: whichTabShow,
                    treeOptions: {
                        nodeChildren: "CHILDREN",
                        dirSelectable: true,
                        allowDeselect: false,
                        injectClasses: {
                            ul: "a1",
                            li: "a2",
                            liSelected: "a7",
                            iExpanded: "a3",
                            iCollapsed: "a4",
                            iLeaf: "a5",
                            label: "a6",
                            labelSelected: "rolegrouplabselected"
                        },
                        isLeaf: function(node) {
                            return node.HASCHILDREN === "false";
                        }
                    },
                    defultGroupid: $location.search().groupid ? true : false, //默认的groupid
                    isAddOrEdit: item.OPTYPE == '新增用户' ? 'add' : 'edit',
                    UserName: item.USERPINYIN, //用户名称
                };
                $scope.data = {
                    globalName:nameChange.globalName,
                    modalTitle: item.OPTYPE == '新增用户' ? "新增" : "修订",
                    selectedRole: [],
                    treeData: [],
                    groupPaths: [],
                    groupPath: "", //页面显示的8531组织路径
                    MLFgroupPath: "", //页面显示的MLF组织路径
                    currUser: {

                    },
                    currMLFUser: {

                    },
                    confIrmpwd: "",
                    selectedGroup: [],
                    selectedUserInfo: [], //选中的用户信息
                };
                $scope.list = {
                    ISUSERNAME: 0,

                };
                $scope.params = { //保存用户
                    serviceid: "mlf_usermanagement",
                    methodname: "saveFWSynUser",
                    UserId: 0,
                    SynUserId: item.SYNUSERID,
                };
            }
            /**
             * [initData description]初始化数据
             */
            function initData() {
                $scope.data.selectedUserInfo[0] = "";
                getTreeData();
                requestData();
            }
            /*
            获取用户详细信息(初始化用户信息)
             */
            function requestData() {
                //根据用户ID获取需要同步的用户信息
                getSynUserDetail();
                if ($scope.status.isAddOrEdit == "edit") {
                    queryMLFUserById();
                }
            }
            //根据用户ID获取需要同步的用户信息
            function getSynUserDetail() {
                var params = {
                    "serviceid": "mlf_usermanagement",
                    "methodname": "getSynUserDetail",
                    "SynUserId": $scope.status.SynUserId
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.data.currUser = data[0].SYNUSER; //用户信息
                    $scope.data.groupPath = data[0].GROUPPATH; //组织路径
                });
            }
            //根据用户ID获取MLF的用户信息
            function queryMLFUserById() {
                var params = {
                    "serviceid": "mlf_usermanagement",
                    "methodname": "getUserDetail",
                    "UserName": $scope.status.UserName
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.data.currMLFUser = data.USER[0];
                    $scope.data.selectedRole = data.ROLEDATA;
                    if (data.GROUP.length > 0) {
                        getGroupPaths(trsspliceString.spliceString(data.GROUP, "GROUPID", ","), "/");
                    }
                    if (data.ROLEDATA.length > 0) {
                        $scope.data.oldRoleIds = trsspliceString.spliceString(angular.copy(data.ROLEDATA), "ROLEID", ",");
                    }
                });
            }
            //根据组织IDS获取组织路径
            function getGroupPaths(groupIds, dcim) {
                var params = {
                    "serviceid": "mlf_group",
                    "methodname": "getGroupPaths",
                    "GroupIds": groupIds,
                    "dcim": dcim
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.data.groupPaths = data;
                    $scope.data.oldGroupPaths = angular.copy($scope.data.groupPaths);
                });
            }
            //checkBox选择处理
            $scope.selectedInfo = function(value) {
                if ($scope.data.selectedUserInfo.indexOf(value) < 0) {
                    $scope.data.selectedUserInfo.push(value);
                } else {
                    $scope.data.selectedUserInfo.splice($scope.data.selectedUserInfo.indexOf(value), 1);
                }
            };
            /**
             * 删除角色
             */
            function delSelectedRole() {
                var params = {
                    serviceid: "mlf_usermanagement",
                    methodname: "deleteUserRoles",
                    UserId: $scope.data.currUser.USERID,
                    RoleIds: delSelectedRoleIds
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {});
            }
            //新建or修改：点击确定
            $scope.confirm = function() {
                //1、新建：
                //选中了哪些（注意必填项）
                //2、修改：（改哪些）
                if ($scope.status.isAddOrEdit == "add") {
                    checkIsSelected().then(function() {
                        saveUser($scope.params, $scope.data.selectedRole).then(function(data) {
                            modalDialog.alertType('同步成功', "", "success", false, function() {
                                $modalInstance.close();
                            });
                        });
                    });
                } else {
                    updateUser($scope.data.selectedRole).then(function(data) {
                        modalDialog.alertType('同步成功', "", "success", false, function() {
                            $modalInstance.close();
                        });
                    });
                }
            };

            /**
             * [checkIsSelected description]新建时：判断勾选了哪些，设置同步所需的参数
             * @return {[type]} [description]
             */
            function checkIsSelected() {
                var defer = $q.defer();
                angular.forEach($scope.data.selectedUserInfo, function(value, key) {
                    if ($scope.data.selectedUserInfo.indexOf('USERNAME') < 0) {
                        modalDialog.alertType('用户名必选', "请检查所选项", "warning", false);
                        if ($scope.status.whichTabShow != 'userInfo') {
                            $scope.status.whichTabShow = 'userInfo';
                        }
                        return;
                    }
                    if ($scope.data.selectedUserInfo.indexOf('GROUPPATH') < 0) {
                        modalDialog.alertType('组织信息必选', "请检查所选项", "warning", false);
                        if ($scope.status.whichTabShow != 'userInfo') {
                            $scope.status.whichTabShow = 'userInfo';
                        }
                        return;
                    }
                    if ($scope.data.selectedUserInfo.indexOf('USERPINYIN') < 0) {
                        modalDialog.alertType('正式姓名必选', "请检查所选项", "warning", false);
                        if ($scope.status.whichTabShow != 'userInfo') {
                            $scope.status.whichTabShow = 'userInfo';
                        }
                        return;
                    }
                    if ($scope.data.selectedUserInfo.indexOf(value) > 0) {
                        if (value == 'USERNAME') {
                            $scope.params.USERNAME = $scope.data.currUser.USERNAME; //用户名
                        }
                        if (value == 'USERPINYIN') {
                            $scope.params.NICKNAME = $scope.data.currUser.USERPINYIN; //昵称
                            $scope.params.TRUENAME = $scope.data.currUser.USERPINYIN; //真实姓名
                        }
                        $scope.params.PASSWORD = $scope.data.currUser.PASSWORD; //默认密码，后端初始化

                        if (value == 'EMAIL') {
                            $scope.params.EMAIL = $scope.data.currUser.EMAIL; //email
                        }
                        if (value == 'ADDRESS') {
                            $scope.params.ADDRESS = $scope.data.currUser.ADDRESS; //地址
                        }
                        if (value == 'MOBILE') {
                            $scope.params.MOBILE = $scope.data.currUser.MOBILE; //手机号码
                        }
                        if (value == 'GROUPPATH') {
                            $scope.params.GroupIds = $scope.data.currUser.DEPARTID; //部门id
                        }
                    }
                    if ($scope.params.USERNAME != "" && $scope.params.GroupIds != "" && $scope.params.NICKNAME != "") {
                        defer.resolve("succsss");
                    }
                });
                return defer.promise;
            }

            //保存用户
            function saveUser(params, selectedRole) {
                var defer = $q.defer();
                var params = params;
                if (selectedRole.length > 0) { //角色
                    params.RoleIds = trsspliceString.spliceString(selectedRole, "ROLEID", ",");
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                    defer.resolve(data);
                });
                return defer.promise;
            }
            //修订用户
            function updateUser(selectedRole) {
                var defer = $q.defer();
                $scope.params.UserId = $scope.data.currMLFUser.USERID; //用户ID
                $scope.params.USERNAME = $scope.data.currUser.USERPINYIN; //用户名
                $scope.params.PASSWORD = $scope.data.currUser.PASSWORD; //默认密码，后端初始化

                $scope.params.NICKNAME = $scope.data.currMLFUser.NICKNAME; //昵称
                $scope.params.TRUENAME = $scope.data.currMLFUser.TRUENAME; //真实姓名
                $scope.params.EMAIL = $scope.data.currMLFUser.EMAIL; //email
                $scope.params.ADDRESS = $scope.data.currMLFUser.ADDRESS; //地址
                $scope.params.MOBILE = $scope.data.currMLFUser.MOBILE; //手机号码  
                $scope.params.GroupIds = trsspliceString.spliceString($scope.data.groupPaths, "GROUPID", ","); //部门id
                $scope.params.USERNUM = $scope.data.currMLFUser.USERNUM; //员工号

                angular.forEach($scope.data.selectedUserInfo, function(value, key) {
                    if ($scope.data.selectedUserInfo.indexOf(value) > 0) {
                        if (value == 'USERPINYIN') {
                            $scope.params.NICKNAME = $scope.data.currUser.USERPINYIN; //昵称
                            $scope.params.TRUENAME = $scope.data.currUser.USERPINYIN; //真实姓名
                        }
                        if (value == 'EMAIL') {
                            $scope.params.EMAIL = $scope.data.currUser.EMAIL; //email
                        }
                        if (value == 'ADDRESS') {
                            $scope.params.ADDRESS = $scope.data.currUser.ADDRESS; //地址
                        }
                        if (value == 'MOBILE') {
                            $scope.params.MOBILE = $scope.data.currUser.MOBILE; //手机号码
                        }
                        if (value == 'GROUPPATH') {
                            $scope.params.GroupIds = $scope.data.currUser.DEPARTID; //部门id
                        }
                    }
                });

                if (selectedRole.length > 0) { //角色
                    $scope.params.RoleIds = trsspliceString.spliceString(selectedRole, "ROLEID", ",");
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "post").then(function(data) {
                    defer.resolve(data);
                });
                return defer.promise;
            }
            /**
             * [showToggle description]树展开方法
             * @param  {[obj]} node [description]父节点
             * @return {[type]}        [description]
             */
            $scope.showToggle = function(node) {
                childrenTree(node, function() {});
            };
            /**
             * [childrenTree description获取子组织]
             * @param  {[type]}   node     [description]
             * @param  {Function} callback [description]
             * @return {[type]}            [description]
             */
            function childrenTree(node, callback) {
                if (node.HASCHILDREN == "true" && node.CHILDREN.length === 0) {
                    var paramsT = {
                        "serviceid": "mlf_group",
                        "methodname": "queryChildGroupsWithSecondRight",
                        "GroupId": node.GROUPID
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), paramsT, "get").then(function(dataC) {
                            node.CHILDREN = dataC.CHILDREN;
                            callback();
                        },
                        function(dataC) {
                            modalDialog.alertType("错误提示", "获取子组失败", "warning", false, function() {});
                        });
                }
            }
            /**
             * [showSelected description]点击组织树节点
             * @param  {[obj]} node [description]点击的节点
             * @return {[type]}        [description]
             */
            $scope.showSelected = function(node) {
                $scope.GroupId = node.GROUPID;
            };
            /**
             * [getTreeData description]获取树数据
             * @param  {[obj]} params [description]请求参数
             * @param  {[string]} roleid   [description]角色Id非必传
             * @return {[type]}        [description]
             */
            function getTreeData() {
                treeService.queryGroupTreeWithSecondRight().then(function(data) {
                    $scope.data.treeData = [data];
                    ExpandedNodes();
                });
            }

            //默认展开树开始
            function ExpandedNodes() {
                $scope.expandedTest = [];
                $scope.expandedTest.push($scope.data.treeData[0]);
                if ($scope.data.treeData[0].CHILDREN === 0) {
                    $scope.selectedNode = $scope.data.treeData[0];
                    getGroupData($scope.selectedNode);
                } else {
                    angular.forEach($scope.data.treeData[0].CHILDREN, function(data, index, array) {
                        if (data.ISPATH === "true") {
                            $scope.expandedTest.push(data);
                            if (data.CHILDREN.length !== 0) {
                                // selfPath(data);
                            } else {
                                $scope.selectedNode = data;
                                getGroupData($scope.selectedNode);
                            }

                        }
                    });
                }
            }
            //默认展开树结束
            function getGroupData(node) {
                $timeout(function() {
                        //此判断如果两次点击同一个树，不重复加载角色列表。
                        if ($scope.oldSelectNode !== undefined && node.GROUPID == $scope.oldSelectNode.GROUPID) {
                            return;
                        }
                        $scope.groupObj = node;
                        $scope.oldSelectNode = node;
                        $scope.roleDatas = [];
                        $scope.roleData = null;
                        var params = {
                            "serviceid": "mlf_extrole",
                            "methodname": "query",
                            "GroupId": $scope.groupObj.GROUPID
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                            $scope.data.roleDatas = data;
                        }, function(data) {});
                    },
                    100);
            }
            //点击树回调函数开始
            $scope.showSelected = function(node) {
                getGroupData(node);
            };
            //点击树回调函数结束



            //单击列表项效果
            $scope.chooseUserName = function(type, role) {
                if (angular.isDefined(role.selected) && role.selected === "selected") {
                    role.selected = "";
                } else {
                    role.selected = "selected";
                    if (type == "toChoose") {
                        $scope.toChooseUser = role;
                    } else if (type == "cancelChoose") {
                        $scope.cancelChooseUser = role;
                    }
                }
            };
            //初始化选择列表
            $scope.toRight = function() {
                angular.forEach($scope.data.roleDatas, function(data, index, array) {
                    if (data.selected === "selected") {
                        $scope.data.roleDatas[index].selected = "";
                        $scope.data.selectedRole.push(angular.copy($scope.data.roleDatas[index]));
                    }
                });
            };
            //双击选择开始
            $scope.directlyToRight = function(role) {
                role.selected = "";
                $scope.data.selectedRole.push(angular.copy(role));
            };
            //双击选择结束
            //双击取消选择开始
            $scope.directlyToLeft = function(role) {
                role.selected = "";
                $scope.data.selectedRole.splice($scope.data.selectedRole.indexOf(role), 1);
            };
            //双击取消选择结束
            //选中删除
            $scope.toLeft = function() {
                var i = $scope.data.selectedRole.length - 1;
                while (i >= 0) {
                    if (angular.isDefined($scope.data.selectedRole[i]) && $scope.data.selectedRole[i].selected === "selected") {
                        $scope.data.selectedRole.splice(i, 1);
                    }
                    i--;
                }
            };
            //全选
            $scope.selectedAll = function() {
                $scope.data.selectedRole = [];
                angular.forEach($scope.data.roleDatas, function(data, index, array) {
                    $scope.data.roleDatas[index].selected = "";
                    $scope.data.selectedRole.push(angular.copy($scope.data.roleDatas[index]));
                });
            };

            //取消
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };

            /**
             * [getSuggestions description]角色全局搜索
             * @param  {[type]} viewValue [description]
             * @return {[type]}           [description]
             */
            $scope.getSuggestions = function(viewValue) {
                if (viewValue != '') {
                    var searchUsers = {
                        serviceid: "mlf_extrole",
                        methodname: "searchRole",
                        Name: viewValue,
                        IsHasRight: true,
                    };
                    if ($scope.isRequest) {
                        $scope.isRequest = false;
                        return [];
                    } else {
                        return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), searchUsers, "post").then(function(data) {
                            return data;
                        });
                    }
                }
            };
            $scope.$watch('searchRoleWord', function(newValue, oldValue) {
                if (angular.isObject(newValue)) {
                    var flag = true;
                    angular.forEach($scope.data.selectedRole, function(data, index, array) {
                        if (data.ROLEID == newValue.ROLEID) {
                            flag = false;
                        }
                    });
                    if (flag) {
                        $scope.isRequest = true;
                        $scope.data.selectedRole.push(newValue);
                    }
                    $scope.searchRoleWord = newValue.ROLENAME;
                }
            });
        }
    ]);
